export const candidate = {
    labels: {
        full_name: "Full Name",
        social_name: "Social Name",
        gender: "Gender",
        about: "About and Hobbies",
    },
    placeholders: {
        full_name: "Enter your full name",
        social_name: "Enter your social name",
        about: "Tell us a bit about yourself and your hobbies.",
    },
    texts: {
    },
};
